import { Skeleton } from "../ui/skeleton";
import { motion } from "framer-motion";

export const NoticeAnalysisSkeleton = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="space-y-6 max-w-4xl mx-auto"
    >
      {/* Progress Indicator */}
      <div className="glass rounded-2xl p-6 border border-cyan-500/30">
        <div className="flex items-center gap-4 mb-4">
          <div className="relative">
            <div className="w-12 h-12 rounded-full border-4 border-cyan-500/30 border-t-cyan-500 animate-spin"></div>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-white mb-1">Analyzing Your Notice</h3>
            <p className="text-sm text-slate-400">Our AI is reviewing your document. This may take 60-90 seconds...</p>
          </div>
        </div>
        
        {/* Progress Steps */}
        <div className="space-y-3 mt-6">
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 rounded-full bg-cyan-500 flex items-center justify-center">
              <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <span className="text-slate-300 text-sm">Document uploaded successfully</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 rounded-full bg-cyan-500/50 flex items-center justify-center animate-pulse">
              <div className="w-2 h-2 rounded-full bg-cyan-300"></div>
            </div>
            <span className="text-slate-400 text-sm">Extracting notice details...</span>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 rounded-full bg-slate-700 flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-slate-500"></div>
            </div>
            <span className="text-slate-500 text-sm">Generating analysis & recommendations</span>
          </div>
        </div>
      </div>

      {/* Skeleton Tabs */}
      <div className="flex gap-1 p-1 bg-slate-800/50 rounded-xl overflow-x-auto">
        {['Summary', 'Analysis', 'Timeline', 'Action', 'Docs', 'Draft'].map((tab, idx) => (
          <div
            key={tab}
            className={`px-4 py-2.5 rounded-lg ${idx === 0 ? 'bg-cyan-500/30' : 'bg-slate-700/30'}`}
          >
            <Skeleton className="h-4 w-16 bg-slate-600/50" />
          </div>
        ))}
      </div>

      {/* Skeleton Content Card */}
      <div className="glass rounded-2xl p-6 space-y-6">
        {/* Header Info Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-slate-800/50 rounded-xl p-4">
              <Skeleton className="h-3 w-20 mb-2 bg-slate-600/50" />
              <Skeleton className="h-5 w-24 bg-slate-500/50" />
            </div>
          ))}
        </div>

        {/* Main Content Area */}
        <div className="space-y-4">
          <Skeleton className="h-4 w-3/4 bg-slate-600/50" />
          <Skeleton className="h-4 w-full bg-slate-600/50" />
          <Skeleton className="h-4 w-5/6 bg-slate-600/50" />
          <Skeleton className="h-4 w-2/3 bg-slate-600/50" />
        </div>

        {/* Action Items Skeleton */}
        <div className="space-y-3">
          <Skeleton className="h-5 w-32 bg-slate-500/50" />
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-start gap-3 p-3 bg-slate-800/50 rounded-xl">
              <Skeleton className="h-5 w-5 rounded-full bg-slate-600/50" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-full bg-slate-600/50" />
                <Skeleton className="h-3 w-2/3 bg-slate-700/50" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Fun Loading Messages */}
      <div className="text-center">
        <p className="text-slate-500 text-sm animate-pulse">
          💡 Tip: Our AI is reviewing case laws and precedents to give you the best analysis
        </p>
      </div>
    </motion.div>
  );
};

export default NoticeAnalysisSkeleton;
